import type { DataTypes } from 'fitify-ui-landing/src/@types'

export const reviewsData: DataTypes.ReviewItem[] = [
  {
    title: 'landing_page_user_review_m_1_title',
    name: 'landing_page_user_review_m_1_name',
    description: 'landing_page_user_review_m_1_description',
  },
  {
    title: 'landing_page_user_review_f_1_title',
    name: 'landing_page_user_review_f_1_name',
    description: 'landing_page_user_review_f_1_description',
  },
  {
    title: 'landing_page_user_review_m_2_title',
    name: 'landing_page_user_review_m_2_name',
    description: 'landing_page_user_review_m_2_description',
  },
  {
    title: 'landing_page_user_review_f_2_title',
    name: 'landing_page_user_review_f_2_name',
    description: 'landing_page_user_review_f_2_description',
  },
  {
    title: 'landing_page_user_review_m_3_title',
    name: 'landing_page_user_review_m_3_name',
    description: 'landing_page_user_review_m_3_description',
  },
  {
    title: 'landing_page_user_review_f_3_title',
    name: 'landing_page_user_review_f_3_name',
    description: 'landing_page_user_review_f_3_description',
  },
]

export const businessReviewsData: DataTypes.ReviewItem[] = [
  {
    name: 'landing_work_review_1_name',
    job: 'landing_work_review_1_job',
    description: 'landing_work_review_1_body',
  },
  {
    name: 'landing_work_review_2_name',
    job: 'landing_work_review_2_job',
    description: 'landing_work_review_2_body',
  },
  {
    name: 'landing_work_review_3_name',
    job: 'landing_work_review_3_job',
    description: 'landing_work_review_3_body',
  },
]
